import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import {MapComponent} from "../../Common/ServiceAreaMap/MapComponent";
import { hitGetServiceProfessionalApi } from "../../../Redux/Professional/GetServiceSlice";
import { hitCreateProfileApi } from "../../../Redux/Professional/CreateProfileSlice";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import { showToast } from "../../../Helper/Toast";
import GoogleAddressInput from "../../Common/GoogleAddressInput/GoogleAddressInput";
//import ServiceAreaMap from "../../Common/ServiceAreaMap/ServiceAreaMap";
import successIcon from "../../../assets/img/tick signup-three icon.svg";
import location_bg_green from "../../../assets/img/location_bg_green.svg";
import akar_icons_location from "../../../assets/img/akar-icons_location.svg";
import { Plus } from "lucide-react";
import GoogleMapsPlacesProvider from "../../Common/GoogleMaps/GoogleMapsPlacesProvider";

const SignUpStepThreeInner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [placeId, setPlaceId] = useState("");

  const [professionalData, setProfessionalData] = useState(null);
  const [servicesData, setServicesData] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState(null);
  const [goNext, setGoNext] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [founderOfferEnabled, setFounderOfferEnabled] = useState(true);
  const [zipCode, setZipCode] = useState("");
  const [address, setAddress] = useState("");

  const [formDataLocation, setFormDataLocation] = useState({
    address: "",
    city: "",
    state: "",
    zip: "",
    lat: "",
    lng: "",
    placeId: "",
   // distance: "",
  });

  useEffect(() => {
    // Enable "Next" button only if address and selected services are provided
    if (formDataLocation.address && selectedServices.length > 0) {
      setGoNext(true);
    } else {
      setGoNext(false);
    }
  }, [formDataLocation, selectedServices]);


  
    // Google Places Autocomplete hook
    const {
      ready,
      value: placeValue,
      suggestions: { status, data },
      setValue: setPlaceValue,
      clearSuggestions,
    } = usePlacesAutocomplete({
      requestOptions: {
        types: ["(cities)"],
        componentRestrictions: { country: "us" }
      },
      debounce: 300,
    });
  
    // Handle place selection
    const handleSelectPlace = async (description) => {
      setPlaceValue(description, false);
      clearSuggestions();
      setFormDataLocation((prev) => ({ ...prev, address: description }));
      try {
        const results = await getGeocode({ address: description });
        if (results && results.length > 0) {
          const { lat, lng } = await getLatLng(results[0]);
          let city = "", state = "", country = "", zip = "", placeId="";
          results[0].address_components.forEach((comp) => {
            if (comp.types.includes("locality")) city = comp.long_name;
            if (comp.types.includes("administrative_area_level_1")) state = comp.long_name;
            if (comp.types.includes("country")) country = comp.long_name;
            if (comp.types.includes("postal_code")) zip = comp.long_name;
          });
          placeId = results[0].place_id;
          setFormDataLocation({
            address: description,
            city,
            state,
            country,
            zip,
            lat,
            lng,
            placeId,
          });
          setPlaceId(placeId);
        }
      } catch (err) {
        // handle error
      }
    };



  useEffect(() => {
    const storedData = localStorage.getItem("professionalToken");
    if (storedData) {
      fetchProfessionalData();
    }
    fetchAppSettings();
  }, []);

  const fetchAppSettings = async () => {
    try {
      const response = await dispatch(hitGetSettingsApi());
      if (response?.payload?.status === true && response.payload.data) {
        setFounderOfferEnabled(
          Number(response.payload.data.isProFounderOfferOnOff) === 1
        );
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const buildStepThreePayload = (profileStep) => {
    const payload = {
      profileSteps: profileStep,
      zipCode: formDataLocation.zip,
      address: formDataLocation.address,
      city: formDataLocation.city,
      state: formDataLocation.state,
      latitude: formDataLocation.lat,
      longitude: formDataLocation.lng,
      placeId: formDataLocation.placeId,
    };

    if (selectedServices && selectedServices.length > 0) {
      payload.serviceIds = selectedServices.map((service) => service._id);
    }

    return payload;
  };

  // Set placeId and address if profile data is loaded
  useEffect(() => {
    if (professionalData && professionalData.defaultServiceArea) {
      const area = professionalData.defaultServiceArea;
      setPlaceId(area.placeId || "");
      setAddress(area.address || "");
      setFormDataLocation({
        address: area.address || "",
        city: area.city || "",
        state: area.state || "",
        zip: area.zipCode || "",
        lat: area.latitude || "",
        lng: area.longitude || "",
        placeId: area.placeId || "",
      });
    }
  }, [professionalData]);

  const submitThirdStep = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const settingsResponse = await dispatch(hitGetSettingsApi());
      const settings = settingsResponse?.payload?.data || {};
      const isFounderOfferOn =
        Number(settings.isProFounderOfferOnOff) === 1;

      setFounderOfferEnabled(isFounderOfferOn);

      const profileStep = isFounderOfferOn ? 3 : 4;
      const formData = buildStepThreePayload(profileStep);

      const response = await dispatch(hitCreateProfileApi(formData));

      if (response?.payload?.status === true) {
        if (isFounderOfferOn) {
          navigate("/professional/signup-four");
        } else {
          navigate("/professional/dashboard");
        }
      } else {
        showToast(
          response?.payload?.message || "Failed to save your profile.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting step three:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const fetchProfessionalData = async () => {
    try {
      const response = await dispatch(hitGetProfileApi());

      const data = response.payload.data;
      const area = data.defaultServiceArea || {};

      // Update all states
      setProfessionalData(data);
      setAddress(area.address || "");
      setFormDataLocation({
        address: area.address || "",
        city: area.city || "",
        state: area.state || "",
        zip: area.zipCode || "",
        lat: area.latitude || "",
        lng: area.longitude || "",
        placeId: area.placeId || "",
      });
      setSelectedServices(data.serviceIds || []);
      setPlaceValue( area.address || "", false);
    } catch (error) {
      console.error("Error fetching professional data:", error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      fetchServices(search);
    }
  };

  useEffect(() => {
    if (search === "") {
      fetchServices(); // call API again with no search
    }
  }, [search]);

  // get service
  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async (search = "") => {
    try {
      const response = await dispatch(hitGetServiceProfessionalApi(search));
      setServicesData(response.payload.data);
      // Handle the response as needed
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  // Function to handle adding/removing services from selectedServices
  const handleServiceClick = (service) => {
    setSelectedServices((prevSelected) => {
      // Check if the service is already selected
      if (prevSelected.some((selected) => selected._id === service._id)) {
        // If it's already selected, remove it
        return prevSelected.filter((selected) => selected._id !== service._id);
      } else {
        // If it's not selected, add it
        // remove selected service from servicesData
        setServicesData((prevServices) =>
          prevServices.filter((s) => s._id !== service._id),
        );
        return [...prevSelected, service];
      }
    });
  };

  // Function to handle removing a service from selectedServices
  const handleRemoveService = (serviceId) => {
    setSelectedServices((prevSelected) =>
      prevSelected.filter((service) => service._id !== serviceId),
    );
    // add removed service back to servicesData
    const removedService = selectedServices.find(
      (service) => service._id === serviceId,
    );
    if (removedService) {
      // set at 0 index
      setServicesData((prevServices) => [removedService, ...prevServices]);
    }
  };



  return (
    <div className="custom_container pro-signup-page">
      <div className="business-form">
        {/* Header */}
        {/* <div className="business-form__header">
          <div className="business-form__step">
            <span className="business-form__step-badge">
              <DoneOutlinedIcon />
            </span>
            <div>
              <span className="title_head">Service Area</span>
              <p
                className="business-form__step__number mb-0"
                style={{ width: "auto" }}
              >
                Step 3 of 4
              </p>
            </div>
          </div>
          <p className="business-form__exit">3/4</p>
        </div> */}

        <div
          className="bussiness-form-header-top"
          style={{ background: "#f1f7fd" }}
        >
          <div className="business-form__header">
            <div
              className="business-form__step"
              style={{ alignItems: "center" }}
            >
              <span
                className="business-form__step-badge"
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                }}
              >
                3
              </span>
              <div>
                <span className="title_head" style={{ color: "#cc4645" }}>
                  Services & Area
                </span>
              </div>
            </div>
            <p className="business-form__exit">
              {founderOfferEnabled ? "3/4" : "3/3"}
            </p>
          </div>
          <div
            className="progress-bar-container"
            style={{ background: "#edf0f3" }}
          >
            <div
              className="progress-bar-fill"
              style={{
                width: founderOfferEnabled ? "50%" : "100%",
                background: "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
              }}
            ></div>
          </div>
          <p
            className="business-form__step__number mb-0"
            style={{
              background: "#fff",
              color: "#6a7280",
              fontWeight: "500",
              padding: "6px 12px",
              marginTop: 10,
            }}
          >
            {founderOfferEnabled ? "Step 3 of 4" : "Step 3 of 3"}
          </p>
        </div>

        {/* Title */}
        <div className="business-form__title mt-0">
          <div className="service_area_search">
            <p
              style={{
                background: "#fcf3f9",
                border: "1px solid #fbf1fb",
                fontWeight: "bold",
              }}
            >
              <img src={akar_icons_location} alt="akar-icons_location" />
              <span>Services & Area</span>
            </p>
          </div>
          <h2>What services do you offer?</h2>
          <p>Pick your services and define your working areas.</p>
        </div>

        {/* Form */}
        <form>
          <label>
            <span>1</span>Service Selection
          </label>
          <div className="service_area_search_input">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search Services..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <label className="mb-0">
            <span className="service_area_span"></span>Service Selection (
            {selectedServices.length})
          </label>
          <div className="selected_top_show">
            <div className="service_show_selected">
              {selectedServices &&
                selectedServices.map((service) => (
                  <p className="service_show_" key={service.id}>
                    {service.name}{" "}
                    <CloseIcon
                      onClick={() => handleRemoveService(service._id)}
                    />
                  </p>
                ))}
            </div>
          </div>
          <div className="service_show_height">
            {servicesData && servicesData.length > 0 ? (
              servicesData.map((service) => (
                <p
                  className="service_show"
                  key={service.id}
                  onClick={() => handleServiceClick(service)}
                >
                  {service.name}
                </p>
              ))
            ) : (
              <p>No services available</p>
            )}
          </div>

          {/* Verification Box */}
          <label className="mt-3 mb-0">
            <span
              style={{
                background: "linear-gradient(90deg, #53B27C 0%, #186639 100%)",
              }}
            >
              2
            </span>
            Choose Your Service Area
          </label>
          <div className="verification-box mt-0 mb-0">
            {/* <img src={verify} alt="success" className="mt-1" /> */}
            <div className="verification-box__content">
              <p className="verification-title" style={{ color: "#000" }}>
                This is where you can submit bids and get discovered by clients
              </p>
              <span style={{ color: "#64748b" }}>
                You’ll still see out-of-area jobs, but can only bid within your
                selected zones.You can add more service area anytime.
              </span>
            </div>
          </div>

          <div className="verification-box mt-0">
            <img
              src={location_bg_green}
              alt="location_bg_green"
              className="mt-1"
              style={{ width: 36, height: 36 }}
            />
            <div className="verification-box__content">
              <p className="verification-title" style={{ color: "#000" }}>
                Client in your area will discover your services more easily.
              </p>
            </div>
          </div>

          {/* <div>
            <label className="mt-2 mb-2">Location</label>
            <div>
              <GoogleAddressInput
                value={address}
                onAddressSelect={handleAddressSelect}
              />
            </div>
          </div> */}


          <div>
            <label>Location*</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                placeholder="Enter your city or state"
                value={placeValue}
                onChange={e => setPlaceValue(e.target.value)}
                // disabled={!ready}
                autoComplete="off"
                style={{ width: "100%" }}
              />
              {status === "OK" && data.length > 0 && (
                <div style={{
                  position: "absolute",
                  zIndex: 10,
                  background: "#fff",
                  border: "1px solid #ccc",
                  width: "100%",
                  maxHeight: 200,
                  overflowY: "auto"
                }}>
                  {data.map(({ place_id, description }) => (
                    <div
                      key={place_id}
                      style={{ padding: 8, cursor: "pointer" }}
                      onClick={() => handleSelectPlace(description)}
                    >
                      {description}
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>

 <MapComponent placeId={placeId} lat={formDataLocation.lat} lng={formDataLocation.lng} />
    

          <div className="service-area">
            <h2>Service Area</h2>
            <p>Let Customers know where your business provides services</p>


         
            {/* Optionally, add multi-area UI here if needed */}
          </div>

          {/* Buttons */}
          <div className="form-actions">
            <button
              type="submit"
              className="next-btn"
              disabled={!goNext || submitting}
              onClick={(e) => {
                if (!goNext || submitting) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                submitThirdStep(e);
              }}
              style={{
                background: goNext && !submitting ? "#b22222" : "#b3b3b3",
                cursor: !goNext || submitting ? "not-allowed" : "pointer",
              }}
            >
              {submitting ? "Saving..." : "Next →"}
            </button>
            <div className="d-flex justify-content-center mt-2">
              <button
                type="button"
                className="back-btn"
                onClick={() => navigate("/professional/signup-two")}
              >
                ← Back
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const SignUpStepThree = () => (
  <GoogleMapsPlacesProvider>
    <SignUpStepThreeInner />
  </GoogleMapsPlacesProvider>
);

export default SignUpStepThree;
